import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { CoursesState } from './state';


const defaultState: CoursesState = {
  lessonsCategories: [],
  lessons: [],
  lesson: null,
  comments: [],
  books: [],
  book: null,
};

export const coursesModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
